import React, { useState, useEffect } from 'react';
import {useNavigate } from 'react-router-dom';
import Layout from '../../Common/Layout';


const IQHomepage=()=>{
    const [typedIntro2, setTypedIntro2] = useState('');
    const [typedGrade2, setTypedGrade2] = useState('');
    const introText2='The average IQ in India is 81';
    const gradeText2="Take this IQ test and check what is your IQ";
    const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0,0)
    
    const typeIntro = async (introText,setTypedIntro) => {
      for (let i = 0; i < introText.length; i++) {
        await new Promise(resolve => setTimeout(resolve, 100)); 
        setTypedIntro(introText.substring(0, i + 1)); 
      }
    };

    const typeGrade = async (gradeText,setTypedGrade) => {
      for (let i = 0; i < gradeText.length; i++) {
        await new Promise(resolve => setTimeout(resolve, 100));
        setTypedGrade(gradeText.substring(0, i + 1));
      }
    };

    typeIntro(introText2,setTypedIntro2);
    typeGrade(gradeText2,setTypedGrade2);
  }, []);
  var nextPage = {
    
  }
    return <Layout>
          <div className="firstContainer">    
      <h1 id="intro">{typedIntro2}</h1>
      <h1 id="grade">{typedGrade2}</h1>
      <p id="desc">Curious about your cognitive abilities?<br/> Explore your intellectual potential and gain insights into your cognitive strengths by taking our IQ test</p>
      <button id="takeQuizBtn" onClick={()=>navigate('/pre-test',{state:"IQ"})}>Take Test</button>
      
    </div>
    </Layout>
  
}

export default IQHomepage;